module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "editor"
  }, [_c('div', {
    staticClass: "sidebar"
  }, [_c('h1', [_vm._v("Kull")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('Uploader', {
    attrs: {
      "notify": _vm.newFile
    }
  }), _vm._v(" "), (_vm.name) ? _c('p', [_c('strong', [_vm._v("Click and drag on the image to the right")]), _vm._v(" to form selection areas.")]) : _vm._e(), _vm._v(" "), (_vm.src) ? _c('ZoneViewer', {
    staticClass: "zone-viewer",
    attrs: {
      "selections": _vm.selections,
      "batchUpdateSelections": _vm.batchUpdateSelections,
      "originalFilename": _vm.name
    }
  }) : _vm._e(), _vm._v(" "), (_vm.arrayBuffer) ? _c('PDFZoneViewer', {
    staticClass: "zone-viewer",
    attrs: {
      "dimensions": _vm.pdfDimensions,
      "selections": _vm.selections,
      "batchUpdateSelections": _vm.batchUpdateSelections,
      "originalFilename": _vm.name
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('Annotator', {
    attrs: {
      "src": _vm.src,
      "setPdfSize": _vm.setPdfSize,
      "arrayBuffer": _vm.arrayBuffer,
      "name": _vm.name,
      "selections": _vm.selections,
      "addSelection": _vm.addSelection
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("A tool to interactively select text regions of PDFs and images.")]), _vm._v(" Use with "), _c('a', {
    attrs: {
      "href": "https://github.com/jcushman/pdfquery"
    }
  }, [_vm._v("PDFQuery")]), _vm._v(" (Python/PDF) or to make UZN/OCR zone files for "), _c('a', {
    attrs: {
      "href": "https://github.com/tesseract-ocr/tesseract"
    }
  }, [_vm._v("tesseract")]), _vm._v(" (image-to-text).")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("More details (maybe) at "), _c('a', {
    attrs: {
      "href": "https://github.com/jsoma/kull"
    }
  }, [_vm._v("https://github.com/jsoma/kull")]), _vm._v(".")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ac3441a4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Editor.vue
// module id = 97
// module chunks = 2